export default __webpack_public_path__ + "static/media/Group 1329.1beb7077.png";